var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operation-report-edit-button"},[_c('vs-button',{staticClass:"edit-button cursor-pointer",staticStyle:{"padding":"5px 14px"},attrs:{"color":_vm.AISEA_COLOR.BLUE,"type":"border"},on:{"click":_vm.onClick}},[_c('div',{staticClass:"flex justify-center items-center col-gap-2"},[_c('edit-icon')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }